<template>
  <a
    v-if="items && items.length"
    :href="content.link"
    target="_blank"
    class="banner-card d-block"
  >
    <img
      :src="files + content.img"
      :alt="content.title"
      :title="content.title"
      loading="lazy"
      class="banner-card-image"
    />
  </a>
</template>

<script>
const types = {
  top: 1,
  "center-1-a": 3,
  "center-1-b": 4,
  "center-3-a": 13,
  "center-3-b": 14,
  "center-2": 5,
  "right-a": 6,
  "bottom-a": 7,
  "bottom-b": 8,
  "right-b": 9,
  "popup-bottom": 10,
};

const time = 8000;

export default {
  props: {
    type: {
      type: String,
      required: true,
      validator: (v) => Object.keys(types).includes(v),
    },
    h: {
      type: String,
    },
    w: {
      type: String,
    },
  },
  data: () => ({
    i: 0,
    interval: null,
  }),
  computed: {
    items() {
      const items = this.$rest("banners").list.filter(
        ({ category: { id } }) => id === types[this.type]
      );

      return items;
    },
    content() {
      return this.items[this.i];
    },
  },
  methods: {
    start() {
      if (this.interval) return;
      if (this.items && this.items.length > 1) {
        this.interval = setInterval(() => {
          if (this.i + 1 === this.items.length) this.i = 0;
          else this.i++;
        }, time);
      }
    },
  },
  watch: {
    items() {
      this.start();
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style>
.banner-card {
  width: 100%;
  max-width: 100vw;
}
.banner-card-image {
  display: block;
  object-fit: contain;
  width: 100%;
}
</style>
